export default "__VITE_ASSET__c7872704__"